import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENDPOINTS } from '@app/utils/constants/endpoints.constants';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {
  private readonly apiUrl = `${environment.apiBaseUrl}${ENDPOINTS.forgotPassword}`;
  private readonly http = inject(HttpClient);

  public sendForgotPasswordEmail(email: string) {
    return this.http.post(this.apiUrl, { email }, { withCredentials: true });
  }
}
